import {FieldDefinition} from "./FieldDefinition";

export class EntitySchema {
    constructor(public name: string,
                public pluralName: string,
                public fieldDefinitions: FieldDefinition[]) {}
}